<div *ngIf="!verified" class="container-captcha is-block" [ngClass]="error ? 'is-error' : ''">
    <div class="loading m-auto" *ngIf="loading" aria-live="polite"></div>
    <label *ngIf="!loading" class=" checkbox mt-4">
        <input type="checkbox" (change)="verify()">
        <span>
            Bitte bestätigen Sie mit einem Klick auf die Checkbox, dass Sie kein Robotor sind.
        </span>
    </label>
</div>

